export default {
      id: "i-service-research-usage",
      viewBox: "0 0 138 146",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-research",
      toString: function () {
        return this.url;
      }
    }